// extracted by mini-css-extract-plugin
export var actionButton = "_co-t";
export var buttonContainer = "_co-0";
export var buttonContainer2 = "_co-1";
export var buttonSection = "_co-2";
export var details = "_co-3";
export var dropdownItem = "_co-5";
export var dropdownItemsContainer = "_co-4";
export var fileInput = "_co-r";
export var headerButton = "_co-6";
export var icon = "_co-7";
export var input = "_co-8";
export var macroListItem = "_co-9";
export var mainContent = "_co-a";
export var microText = "_co-b";
export var modal = "_co-w";
export var optionsButton = "_co-c";
export var paperclip = "_co-s";
export var pillContent = "_co-d";
export var preview = "_co-e";
export var preview2 = "_co-f";
export var quillEditor = "_co-q";
export var selectedMacro = "_co-g";
export var sidebar = "_co-h";
export var sidebarHeader = "_co-j";
export var sidebarList = "_co-i";
export var sidebarListItem = "_co-k";
export var sidebarSearch = "_co-l";
export var snoozeDurationWrapper = "_co-v";
export var statusPillContainer = "_co-m";
export var tagsContainer = "_co-n";
export var unselectedMacro = "_co-o";
export var variable = "_co-u";
export var wrapper = "_co-p";